import { TemplateRef } from '@angular/core';
import { DismissConfig } from './modal-config';

export interface DrawModalConfig {
  title?: string;
  subtitle?: string;
  content?: string | TemplateRef<any>;
  class?: string;
  params?: object;
  drawing?: Blob | null;
  dismiss?: boolean | DismissConfig;
}
